import BaseSlowConnection from "./BaseSlowConnection.vue";
export default BaseSlowConnection;
